import { render, staticRenderFns } from "./SuccessPhone.vue?vue&type=template&id=a5539a7c&scoped=true"
import script from "./SuccessPhone.vue?vue&type=script&lang=js"
export * from "./SuccessPhone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5539a7c",
  null
  
)

export default component.exports